import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

import { KANBAN_CARD_WIDTH } from "../../common";
import { GAP } from "./const";

export const CardBoardRowStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "card-board-row",
})<{ $columnCount: number }>`
  &:first-child {
    margin-top: 4px;
  }
  display: grid;
  grid-template-columns: repeat(
    ${props => props.$columnCount},
    ${KANBAN_CARD_WIDTH}px
  );
  gap: ${GAP}px;
  align-items: center;
`;
